import { type FieldValues, type UseFormProps, useForm } from 'react-hook-form'

/**
 * アプリケーション全体で使用する useForm のラッパー
 * mode: 'onChange' と reValidateMode: 'onChange' をデフォルトで設定
 */
export const useOnChangeForm = <T extends FieldValues>(
  opts: UseFormProps<T>
) => {
  return useForm<T>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    ...opts
  })
}
